import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  quizScreenContainer: {
    height: "100vh",
    backgroundColor: "#ecf2f1",
  },

  includedTitle: {
    color: "#003e4c",
    fontSize: "46px",
    fontWeight: "500",
    fontFamily: "Oswald",
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
  },

  dropImageStyle: {
    width: "400px",
    height: "100px",
  },

  draggableDrop: {
    border: "3px solid #003e4c",
    borderRadius: "6px",
    backgroundColor: "#fff",
    width: "220px",
    [mobileScreen(theme)]: {
      width: "140px",
    },
  },

  answerTitleIcon: {
    width: "90px",
    height: "40px",
    marginRight: "1rem",
    [mobileScreen(theme)]: {
      width: "50px",
      height: "25px",
      marginRight: "0.8rem",
    },
  },

  answerTitleContainer: {
    backgroundColor: "#003e4c",
    padding: "0.7rem 1rem",
    [mobileScreen(theme)]: {
      padding: "0.5rem",
    },
  },

  answerTitleText: {
    color: "#fff",
    fontSize: "25px",
    fontWeight: "500",
    fontFamily: "Oswald",
    [mobileScreen(theme)]: {
      fontSize: "15px",
    },
  },

  answerDescContainer: {
    // padding: "0 1rem 1rem 1rem",
    height: "200px",
    [mobileScreen(theme)]: {
      height: "110px",
      padding: "0 0.5rem 0.5rem 0.5rem",
    },
  },

  droppableCircle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    marginTop: "1rem",
    border: "3px dashed #003e4c",
    [mobileScreen(theme)]: {
      marginTop: "0.5rem",
      borderWidth: "2px",
      width: "40px",
      height: "40px",
    },
  },

  droppableAnswer: {
    width: "79px",
    height: "79px",
    borderRadius: "50%",
    marginTop: "1rem",
    position: 'relative',
    // willChange: 'transform',
    [mobileScreen(theme)]: {
      marginTop: "0.5rem",
      borderWidth: "2px",
      width: "44px",
      height: "44px",
    },
  },

  notificationText: {
    position: 'absolute',
    color: '#003e4c',
    fontFamily: 'Oswald',
    fontWeight: 'bold',
    // top: 10,
    fontSize: 30,
    right: 50,
    bottom: 28,
    [mobileScreen(theme)]: {
      fontSize: 20,
      right: 36,
      bottom: 14,
    }
  },
  innerDroppableElement: {
    width: "550px",
    flexWrap: "nowrap",
    position: "absolute",
    cursor: "pointer",
    [mobileScreen(theme)]: {
      width: "325px",
    },
  },

  submitButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "30px",
    fontWeight: "500",
    padding: "0px 20px",
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
  },

  evaluatorModalContainer: {
    width: "350px",
    padding: "2rem 3rem",
    backgroundColor: "#fff",
    borderRadius: "6px",
  },

  evalDesc: {
    margin: "24px 0",
    color: "#003e4c",
    fontFamily: "Rubik",
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
    [mobileScreen(theme)]: {
      fontSize: "15px",
      marginBottom: "2px",
    },
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
    [mobileScreen(theme)]: {
      fontSize: "12px",
      maxWidth: "200px",
    },
  },

  questionImg: {
    width: "150px",
    height: "150px",
    marginRight: "2.5rem",
    zIndex: "5",
    userDrag: 'none',
    [mobileScreen(theme)]: {
      width: "100px",
      height: "100px",
      marginRight: "1.5rem",
    },
  },
});

export default styles;
